jQuery(function() {
  var $blocks = jQuery('.animBlock.notViewed');

  $blocks.each(function(i, elem) {
    fadeImageOnLoad(jQuery(this));
  });
});

function fadeImageOnLoad(elem) {
  elem.one('load', function() {
    jQuery(this).removeClass('notViewed').addClass('viewed');

    var animElemsLeft = jQuery('.animBlock.notViewed').length;
    if (animElemsLeft === 0) {
      // Perform any additional actions when all images are loaded and faded
    }
  }).each(function() {
    if (this.complete || /* For modern browsers */ jQuery(this).height() > 0) {
      // Image is already loaded or cached, trigger the load event manually
      jQuery(this).trigger('load');
    }
  });
}
